<template>
  <div class="page-container">
    <header-list></header-list>
    <app-main></app-main>
    <footer-list></footer-list>
  </div>
</template>
<script>
import headerList from "@/components/header";
import footerList from "@/components/footer";
import AppMain from "./components/AppMain";
export default {
  components: { headerList, footerList, AppMain }
};
</script>
<style lang="scss" scoped>
.page-container {
  position:relative;
  height: 100%;
  width: 100%;
  overflow: hidden;
}
@media screen and (max-width: 500px) {
    .page-container {
      width:100%;
    }
}
</style>



// WEBPACK FOOTER //
// src/layout/index.vue